<div class="section p-3">
        <dx-data-grid
          #dataGridManageUser
          id="dataGridManageUser"
          class="manage-user-grid"
          [dataSource]="manageUsersData"
          [allowColumnResizing]="true" 
        [columnResizingMode]="'widget'" 
        [hoverStateEnabled]="true"
        [columnAutoWidth]="true" 
        [allowColumnReordering]="true"
        (onEditingStart)="onEditingStart($event)"
          [showBorders]="true"
          (onInitNewRow)="onAddUser($event)"
          (onSaved)="updateUsers($event)"
        >
        
  <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-paging [pageSize]="100000" emptyPanelText=""></dxo-paging>
          <!-- <dxo-row-dragging
            [allowReordering]="!locked"
            [showDragIcons]="false"
            [onReorder]="true"
            [data]=""
            newRowPosition="last"
        ></dxo-row-dragging> -->
          
          <dxo-editing
            mode="form"
            [allowUpdating]="true"
            [allowAdding]="true"
            [selectTextOnEditStart]="true"
            [allowDeleting]="true"
            *ngIf="!disManageUsers"
          >
          </dxo-editing>

          <dxi-column type="buttons" *ngIf="!locked" [width]="60">
            <dxi-button name="delete"></dxi-button>
            <dxi-button name="edit"></dxi-button>
        </dxi-column> 

        <dxi-column dataField="speId" caption="SPE ID" [allowEditing]="!editRow">
          <dxi-validation-rule type="required"></dxi-validation-rule>
          <dxi-validation-rule
            type="custom"
            [message]="customIDMsg"
            [validationCallback]="customIDValidation"
          ></dxi-validation-rule>

          <!-- <dxi-validation-rule
          *ngIf="userNotAllowed"
            type="custom"
            message="SPE ID is associated with an existing user."
            [validationCallback]="customIDValidation"
          ></dxi-validation-rule> -->
        </dxi-column>
        <dxi-column dataField="firstName" caption="FIRST NAME" [allowEditing]="false">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-column>
        <dxi-column dataField="roleId" 
        dataType="string" 
        caption="ROLE"  
        [allowEditing]="true"   
        editCellTemplate="changeRoleName">
          <dxo-lookup 
            [dataSource]="roleNameData" 
            valueExpr="roleId" 
            displayExpr="roleName">
          </dxo-lookup> 
          <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-column>
     
     <div *dxTemplate="let cellInfo of 'changeRoleName'">
       <dx-select-box
        [dataSource]="roleNameData"
         [value]="cellInfo.value"
         displayExpr="roleName"
         valueExpr="roleId"
         (onValueChanged)="updateRoleName($event, cellInfo)"
       >
     </dx-select-box>
     </div> 

     <dxi-column dataField="lastName" caption="LAST NAME" [allowEditing]="false">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

<dxi-column dataField="departmentId" 
dataType="string" 
caption="DEPARTMENT"  
[allowEditing]="true"   
editCellTemplate="changeDeptName">
  <dxo-lookup 
    [dataSource]="departmentData" 
    valueExpr="picklistDetailId" 
    displayExpr="value">
  </dxo-lookup>
  <dxi-validation-rule type="required"></dxi-validation-rule>
</dxi-column>

<div *dxTemplate="let cellInfo of 'changeDeptName'">
<dx-select-box
[dataSource]="departmentData"
[value]="cellInfo.value"
 displayExpr="value"
 valueExpr="picklistDetailId"
 (onValueChanged)="updateDeptName($event, cellInfo)"
>
</dx-select-box>
</div>
        
       
        
        <dxi-column dataField="email" caption="EMAIL"[allowEditing]="false">
          <dxi-validation-rule type="required"></dxi-validation-rule>
          <dxi-validation-rule type="email"></dxi-validation-rule>
          <dxi-validation-rule
            type="custom"
            message="Email is associated with an existing user."
            [validationCallback]="customValidation"
          ></dxi-validation-rule>
        </dxi-column>

        <dxi-column
                        caption="Restricted Access"
                        dataType="boolean"
                        width="6%"
                        dataField="wednesdayAccessFlag">
                    </dxi-column>
        <!-- <dxi-column dataField="roleName">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-column> -->

       

<!-- <dxi-column dataField="departmentName">
  <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-column> -->
        </dx-data-grid>
      
</div>

<app-load-panel *ngIf="showLoadPanel" [option]="loadPanelOption"></app-load-panel>